import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { styled } from '@uhg-abyss/web/tools/styled';
import { DropdownContext } from '../Context';

const StyledDropdownContent = styled('div', {
  display: 'none',
  position: 'absolute',
  backgroundColor: '$white',
  zIndex: 1000,
});
const StyledDropdownContentActive = styled(StyledDropdownContent, {
  display: 'block',
});

export const DropdownContent = ({ className, ...props }) => {
  const { dropdownState, model } = useContext(DropdownContext);

  if (!dropdownState) {
    throw new Error('<Dropdown.Content> needs to be wrapped in a <Dropdown>');
  }

  const isActive = dropdownState.model === model;
  const Component = isActive
    ? StyledDropdownContentActive
    : StyledDropdownContent;

  return <Component {...props} role="presentation" className={className} />;
};

DropdownContent.propTypes = {
  className: PropTypes.string,
};

DropdownContent.defaultProps = {
  className: null,
};
